<!-- Staging badge -->
<ng-container *ngIf="isStaging$ | async">
    <fs-debug-badge></fs-debug-badge>
</ng-container>


<router-outlet></router-outlet>

